export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./create-balance.vue?vue&type=template&id=6c6f2eec&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/players/player/create-balance.vue?vue&type=template&id=6c6f2eec&scoped=true
// module id = Magt
// module chunks = 0